(function() {
	
	var Point = include("PIXI.Point", false) || include("createjs.Point", false);
	
	var Line = function(p1X, p1Y, p2X, p2Y)
	{
		if(typeof p1X != "number")
		{
			//shift p2 back
			p2Y = p2X;
			p2X = p1Y;
			
			p1Y = p1X.y;
			p1X = p1X.x;
		}
		if(typeof p1Y != "number")
		{
			p2X = p1Y.x;
			p2Y = p1Y.y;
		}
		else if(typeof p2X != "number")
		{
			p2Y = p2X.y;
			p2X = p2X.x;
		}
		this.p1 = new Point(p1X, p1Y);
		this.p2 = new Point(p2X, p2Y);
	};
	
	var p = Line.prototype;
	
	p.setTo = function(p1X, p1Y, p2X, p2Y)
	{
		if(typeof p1X != "number")
		{
			//shift p2 back
			p2Y = p2X;
			p2X = p1Y;
			
			p1Y = p1X.y;
			p1X = p1X.x;
		}
		if(typeof p1Y != "number")
		{
			p2X = p1Y.x;
			p2Y = p1Y.y;
		}
		else if(typeof p2X != "number")
		{
			p2Y = p2X.y;
			p2X = p2X.x;
		}
		this.p1.x = p1X;
		this.p1.y = p1Y;
		this.p2.x = p2X;
		this.p2.y = p2Y;
	};
	
	
	namespace('heist').Line = Line;
}());